function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M27.8 66.84a41.19 41.19 0 01-16.69-3.5L9 62.41v68.46h37.59V62.39l-2.11.94a40.85 40.85 0 01-16.68 3.51zm15.79 61H12V67a44.51 44.51 0 0031.58 0zM27.8 0a27.81 27.81 0 1027.81 27.8A27.83 27.83 0 0027.8 0zm0 52.61A24.81 24.81 0 1152.61 27.8 24.84 24.84 0 0127.8 52.61zM83.79 77.3a33.83 33.83 0 01-13.72-2.88L68 73.49v57.38h31.62v-57.4l-2.11.94a33.67 33.67 0 01-13.72 2.89zm12.83 50.57H71V78a37.09 37.09 0 0025.66 0zM83.8 21.91a23.3 23.3 0 1023.29 23.3 23.32 23.32 0 00-23.29-23.3zm0 43.59a20.3 20.3 0 1120.29-20.29A20.31 20.31 0 0183.8 65.5z",
  "data-name": "Layer 1",
  fill: "currentColor"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 107.09 130.87"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/people.svg";
export { SvgComponent as ReactComponent };